import * as React from "react";
const InfoIcon = (props) => (
  <svg
    width={16}
    height={21}
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_44104_55287)">
      <path
        d="M7.99992 16.7708C4.31792 16.7708 1.33325 13.7862 1.33325 10.1042C1.33325 6.42217 4.31792 3.4375 7.99992 3.4375C11.6819 3.4375 14.6666 6.42217 14.6666 10.1042C14.6666 13.7862 11.6819 16.7708 7.99992 16.7708ZM7.99992 15.4375C9.41441 15.4375 10.771 14.8756 11.7712 13.8754C12.7713 12.8752 13.3333 11.5187 13.3333 10.1042C13.3333 8.68968 12.7713 7.33312 11.7712 6.33293C10.771 5.33274 9.41441 4.77083 7.99992 4.77083C6.58543 4.77083 5.22888 5.33274 4.22868 6.33293C3.22849 7.33312 2.66659 8.68968 2.66659 10.1042C2.66659 11.5187 3.22849 12.8752 4.22868 13.8754C5.22888 14.8756 6.58543 15.4375 7.99992 15.4375ZM7.33325 6.77083H8.66659V8.10417H7.33325V6.77083ZM7.33325 9.4375H8.66659V13.4375H7.33325V9.4375Z"
        fill="#8b58f1"
      />
    </g>
    <defs>
      <clipPath id="clip0_44104_55287">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0 2.10156)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default InfoIcon;
